<template>
    <el-table
        :data="tableData"
        style="width: 100%"
        :cell-style="{
            'font-size': '16px',
            color: '#333',
        }"
        :header-cell-style="{
            'background-color': '#e8eff9',
            'font-weight': '700',
            color: '#333',
            'font-size': '14px',
        }"
    >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column
            label="序号"
            prop="rowNum"
            align="center"
            header-align="center"
        >
        </el-table-column>
        <el-table-column
            label="直播课时名称"
            prop="courseName"
            align="center"
            header-align="center"
            sortable
        >
        </el-table-column>
        <el-table-column
            label="批次号/班级编码"
            prop="classCode"
            align="center"
            header-align="center"
        >
        </el-table-column>
        <el-table-column
            label="直播课时 "
            prop="tiem"
            align="center"
            header-align="center"
        >
        </el-table-column>
        <el-table-column
            label="合作院校"
            prop="schoolName"
            align="center"
            header-align="center"
        >
        </el-table-column>
        <el-table-column
            label="合作机构"
            prop="companyName"
            align="center"
            header-align="center"
        >
        </el-table-column>
        <el-table-column
            label="任课老师"
            prop="uname"
            align="center"
            header-align="center"
        >
        </el-table-column>
        <el-table-column
            label="直播时间"
            prop="openTime"
            align="center"
            header-align="center"
        >
        </el-table-column>
        <el-table-column
            label="结束时间"
            prop="endTime"
            align="center"
            header-align="center"
        ></el-table-column>
        <el-table-column
            label="直播地址"
            prop="address"
            align="center"
            header-align="center"
        ></el-table-column>
        <el-table-column
            label="直播说明"
            prop="explain"
            align="center"
            header-align="center"
        ></el-table-column>
        <el-table-column
            label="学习人数"
            prop="learnNum"
            align="center"
            header-align="center"
        ></el-table-column>
        <el-table-column
            label="状态"
            prop="status"
            align="center"
            header-align="center"
        >
            <template slot-scope="scope">
                <div
                    style="color: '#04f91d'"
                    v-show="scope.row.status === 'a开课中'"
                >
                    {{ scope.row.status.slice(1) }}
                </div>

                <div
                    style="color: '#409eff'"
                    v-show="scope.row.status === 'b未开课'"
                >
                    {{ scope.row.status.slice(1) }}
                </div>
                <div
                    style="color: '#7f7f7f'"
                    v-show="scope.row.status === 'c已结课'"
                >
                    {{ scope.row.status.slice(1) }}
                </div>
                <div
                    style="color: '#d9001b'"
                    v-show="scope.row.status === 'd已取消'"
                >
                    {{ scope.row.status.slice(1) }}
                </div>
            </template>
        </el-table-column>
        <el-table-column
            label="出勤率"
            prop="attendanceRate"
            align="center"
            header-align="center"
            sortable
        >
        </el-table-column>
        <el-table-column
            label="操作"
            align="center"
            header-align="center"
            min-width="200"
            class-name="operation"
        >
            <template slot-scope="scope">
                <div class="operation">
                    <span>
                        <el-button type="text" @click="checkInfo(scope.row)">
                            查看
                        </el-button>
                    </span>
                    <span
                        v-if="scope.row.total"
                        @click="reviseInfo(scope.row)"
                        v-show="!isPartner"
                        >修改</span
                    >
                    <span
                        v-if="scope.row.total"
                        v-show="!isPartner"
                        @click="cancelFn(scope.row.id)"
                        >取消</span
                    >
                    <span @click="linkToStudent(scope.row)">学员</span>
                    <span @click="linkToAttendance(scope.row)">考勤</span>
                </div>
                <!-- 弹窗查看信息 -->
                <MyDialog
                    :course="course"
                    :videoId="courseId"
                    :dialogFormVisible.sync="dialogFormVisible"
                    :dialogType="dialogType"
                ></MyDialog>
            </template>
        </el-table-column>
    </el-table>
</template>

<script>
import MyDialog from "./MyDialog.vue";
import {
    getbatchList,
    getBatchById,
    getListByCategory,
    getTeacherBySchool,
    cancelBatch,
} from "@/api/LiveLesson/classTimeapi.js";
export default {
    data() {
        return {
            // 是否给用户操作
            isPartner: this.$route.query.isPartner,
            // 课时管理列表
            tableData: [],
            // 机构列表
            companyList: [],
            // 学校列表
            schoolList: [],
            // 老师列表
            teacherList: [],

            // 弹窗显示
            dialogFormVisible: false,
            // 弹窗类型
            dialogType: "",
            // 查看或修改的课程
            course: {},
        };
    },
    methods: {
        // 弹窗对话框(查看)
        async checkInfo(item) {
            this.dialogType = "check";
            this.course = item;
            this.dialogFormVisible = true;
        },
        // 弹窗对话框(修改)
        async reviseInfo(item) {
            this.dialogType = "edit";
            this.course = item;
            this.dialogFormVisible = true;
        },
        // 取消课时
        async cancelFn(id) {
            await cancelBatch({ id });
        },
        async init() {
            // 课时管理table数据
            const res = await getbatchList({ courseId: this.courseId });
            this.tableData = res.data.data.list;
            // 机构列表
            const company = await getListByCategory({ schoolCategory: 28 });
            this.companyList = company.data.data;
            // 学校列表
            const school = await getListByCategory({ schoolCategory: 27 });
            this.schoolList = school.data.data;
        },
        // 学校名称
        schoolNamebyId(id) {
            const res = this.schoolList.filter((item) => item.id === id);
            return res.title;
        },
        // 机构名称
        companyNamebyId(id) {
            const res = this.companyList.filter((item) => item.id === id);
            return res.title;
        },
        // 跳转到学生
        linkToStudent(item) {
            this.$emit(
                "toStudent",
                // 课程信息
                item,
                // 跳转的表格
                "student"
            );
        },
        // 跳转到编辑
        linkToAttendance(item) {
            this.$emit(
                "toAttendance",
                // 课程信息
                item,
                // 跳转的表格
                "attendance"
            );
        },
    },
    created() {
        this.init();
    },
    components: {
        MyDialog,
    },
    props: {
        tableName: {
            type: String,
        },
        courseId: {
            type: String,
        },
        selectTableData: {
            type: Array,
        },
        page: {
            type: Object,
        },
    },
    watch: {
        selectTableData: {
            immediate: true,
            handler: function (newValue) {
                if (newValue) {
                    this.tableData = newValue;
                }
            },
        },
        page: {
            immediate: true,
            deep: true,
            handler: async function (newValue) {
                if (newValue) {
                    // 课时管理table数据
                    const res = await getbatchList({
                        courseId: this.courseId,
                        page: newValue.page,
                        pageSize: newValue.pageSize,
                    });
                    this.tableData = res.data.data.list;
                    this.$emit("total", this.tableData.length);
                }
            },
        },
    },
};
</script>

<style lang="scss" scoped>
.operation {
    span {
        font-size: 14px;
        color: #6b9eff;
        border-right: 1px solid #6b9eff;
        padding: 5px;
        &:last-child {
            border-right: 0;
        }
    }
    color: #6b9eff;
}
.el-form-item {
    padding-bottom: 20px;
    border-bottom: 1px solid #000;
}
</style>

